<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="input-number-wrapp">
      <div class="flex items-center mb-2">
        <label :for="returnName">
          <span>
            <span class="opacity-50">{{ label }}</span>
            <span v-if="required" class="text-red text-lg leading-none">*</span>
          </span>
        </label>

        <span v-if="tooltip" class="tooltip top">
          <button type="button" class="tooltip-icon" aria-label="info">
            <svg class="w-[6px] h-2">
              <use xlink:href="#icon-question" />
            </svg>

            <i class="tooltip-arrow"></i>
          </button>

          <span class="tooltip-popup">{{ tooltip }}</span>
        </span>
      </div>
      <div class="relative h-16 md:h-[72px]">
        <button
          class="absolute left-[5px] top-[5px] bottom-[5px] w-20 flex items-center justify-center border border-transparent active:scale-[0.95] outline-none duration-200"
          :class="
            theme === 'blue'
              ? 'bg-gray/10 hover:border-white/40 focus-visible:border-white'
              : 'bg-gray hover:border-blue focus-visible:border-blue/70'
          "
          type="button"
          @click="sub()"
          aria-label="minus"
        >
          <span class="block w-5 h-px bg-current"></span>
        </button>

        <input
          class="block h-full w-full text-base text-current font-medium text-center px-24 input-border focus-visible:border-current !outline-none duration-200"
          type="number"
          :id="returnName"
          :name="returnName"
          :value="value"
          placeholder=" "
          @input="inputChange"
          :min="min"
          :max="max"
          maxlength="4"
          autocomplete="off"
        />

        <button
          class="absolute right-[5px] top-[5px] bottom-[5px] w-20 flex items-center justify-center border border-transparent active:scale-[0.95] outline-none duration-200"
          :class="
            theme === 'blue'
              ? 'bg-gray/10 hover:border-white/40 focus-visible:border-white'
              : 'bg-gray hover:border-blue focus-visible:border-blue/70'
          "
          type="button"
          @click="add()"
          aria-label="plus"
        >
          <span class="block w-5 h-px bg-current"></span>
          <span class="absolute block h-5 w-px bg-current"></span>
        </button>
      </div>
    </div>
    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'CalculatorInputNumber',

  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
    tooltip: {
      type: String,
      default: '',
    },
    symbol: {
      type: String,
      default: '',
    },

    max: {
      type: Number,
      default: 999999999,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 0,
    },

    theme: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    returnName() {
      const result = this.label
        .split(' ')
        .join('-')
        .toLowerCase()

      return result
    },
  },
  methods: {
    add(el) {
      let value = parseInt(this.value)

      if (value < this.max) {
        value += this.step
        this.$emit('input', value)
      }
    },
    sub(el) {
      let value = parseInt(this.value)

      if (this.value > this.min) {
        value -= this.step
        this.$emit('input', value)
      }
    },
    inputChange(e) {
      const value = parseInt(e.target.value)

      if (!value) e.target.value = 0
      if (value > this.max) e.target.value = this.max
      if (value < this.min) e.target.value = this.min

      this.$emit('input', parseInt(e.target.value))
    },
  },
}
</script>
